import React, { useEffect, useRef } from 'react';
import './Sidebar.css';

export default function Sidebar({ setActiveSection }) {
    const booksyWidgetRef = useRef(null);

    useEffect(() => {
        if (!booksyWidgetRef.current) return;

        // Ładowanie skryptu Booksy
        const script = document.createElement('script');
        script.type = 'text/javascript';
        script.src = 'https://booksy.com/widget/code.js?id=66454&country=pl&lang=pl';
        script.async = true;
        booksyWidgetRef.current.appendChild(script);

        return () => {
            // Czyszczenie po demontażu komponentu
            if (window.booksy) delete window.booksy;
            if (booksyWidgetRef.current && booksyWidgetRef.current.contains(script)) {
                booksyWidgetRef.current.removeChild(script);
            }
        };
    }, []);

    return (
        // Główny kontener trzymający obie sekcje: prawą (przyciski) i lewą (Booksy)
        <div className="sidebar-master-container">

            {/* 🚨 SEKACJA LEWA: Booksy (Pozycjonowana na dole po lewej, nad ikonami) */}
            <div className="sidebar-left-section">
                <div className="booksy-floating-container">
                    <div
                        ref={booksyWidgetRef}
                        className="booksy-floating-button"
                        style={{ overflowY: 'auto', maxHeight: '80vh' }}
                    >
                        <div data-booksy-widget="true"></div>
                    </div>
                </div>
            </div>

            {/* 🚨 SEKACJA PRAWA: Trzy Przyciski (Pozycjonowana na górze po prawej) */}
            <div className="sidebar-right-section">
                <button className="btn" onClick={() => setActiveSection('about')}>
                    O NAS
                </button>
                <button className="btn" onClick={() => setActiveSection('contact')}>
                    KONTAKT
                </button>
                <button className="btn" onClick={() => setActiveSection('jobs')}>
                    PRACUJ Z NAMI
                </button>
            </div>
        </div>
    );
}